//import interceptors from "../GlobalFunctions/interceptors";


function checkElement (selector){
    return new Promise((resolve, reject) => {
        let resolved = false;
        const checkExistence = setInterval(() => {
            const el = document.querySelector(selector);
            if (el) {
              clearInterval(checkExistence);
              //log test
              console.log('Elemento ' + selector + ' encontrado.');
              resolved = true;
              resolve();
            } else {
                console.log(`Element ${selector} not found`)
            }
          }, 500);
      
          setTimeout(() => {
            if (resolved) return;
            clearInterval(checkExistence);
              //log test
            console.warn('Elemento ' + selector + ' não encontrado após 7s.');
            reject(); 
        }, 30000);
    })
}

//async function waitForApiSuccess() {
 
//}


function createModal (){
    return new Promise((resolve) => {
        const modal = document.createElement('div');
        modal.style.position = 'fixed';
        modal.style.top = '0';
        modal.style.left = '0';
        modal.style.width = '100%';
        modal.style.height = '100%';
        modal.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
        modal.style.zIndex = '1000';
        modal.style.display = 'flex';
        modal.style.alignItems = 'center';
        modal.style.justifyContent = 'center';
        modal.style.zIndex = '1100';
        modal.innerHTML = `
            <div id="coef-modal" style=" background-color: #fff; padding: 20px; border-radius: 8px; text-align: center; width: 500px; height: 500px; zIndex: 1200;
            ">
                <h1 style:"margin-bottom: 10px">Multiplicador</h1>
                <p>O coeficiente angular mostra como os valores se comportam em um gráfico (no gráfico os valores são representados pela reta). 
                Se esse coeficiente/multiplicador for 0 os valores não variam e a reta que representa os valores será horizontal e constante. Se o multiplicador for positivo,
                a reta sobre confnorme os valores aumentam; Se for negativo, a linha desce. 
                </p>
                <img 
                    src="https://images.educamaisbrasil.com.br/content/banco_de_imagens/guia-de-estudo/D/exemplos-relacoes-angulos-lados-coeficiente-angular-matematica.jpg"
                    alt="Exemplo"
                    style="width: 100%; border-radius: 8px; margin: 05px 0;"
                >
                <button id="closeModalButton" style="
                    margin-top: 15px;
                    padding: 10px 20px;
                    background-color: #007BFF;
                    color: #fff;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                ">Fechar</button>
            </div>
        `;
        document.body.appendChild(modal);

        const closeButton = modal.querySelector('#closeModalButton');
        closeButton.addEventListener('click', () => {
            document.body.removeChild(modal); 
            resolve();
        });
    });
}

export { checkElement, createModal };